import { createPortal } from "react-dom";
import { Spinner } from "@/shared/ui/Spinner";

export const PageSpinner = () =>
  createPortal(
    <div className="flex-center bg-muted fixed z-50 h-screen w-screen">
      <Spinner />
    </div>,
    document.body,
  );
